// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectorviewdialog_featured__mNLwl {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.sectorviewdialog_featuredItem__riMos {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.sectorviewdialog_featuredTitleHeader__o3LgX {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.sectorviewdialog_dialogInputs__NYsJN {
    width: 100%;
}

.sectorviewdialog_dialogReadOnlyInputs__2zHpc {
    width: 100%;
    z-index: 1000;
    pointer-events: none;
}

.sectorviewdialog_sectorResearcherViewDialog__mQO2Z {
    min-width: 80vw !important;
    max-width: 80vw !important;
    min-height: 90%;
    max-height: 90%;
}`, "",{"version":3,"sources":["webpack://./src/components/SectorViewDialog/sectorviewdialog.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB","sourcesContent":[".featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.dialogReadOnlyInputs {\r\n    width: 100%;\r\n    z-index: 1000;\r\n    pointer-events: none;\r\n}\r\n\r\n.sectorResearcherViewDialog {\r\n    min-width: 80vw !important;\r\n    max-width: 80vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `sectorviewdialog_featured__mNLwl`,
	"featuredItem": `sectorviewdialog_featuredItem__riMos`,
	"featuredTitleHeader": `sectorviewdialog_featuredTitleHeader__o3LgX`,
	"dialogInputs": `sectorviewdialog_dialogInputs__NYsJN`,
	"dialogReadOnlyInputs": `sectorviewdialog_dialogReadOnlyInputs__2zHpc`,
	"sectorResearcherViewDialog": `sectorviewdialog_sectorResearcherViewDialog__mQO2Z`
};
export default ___CSS_LOADER_EXPORT___;
